module.exports = __webpack_public_path__ + "img/chat.dd22113d.png";